// extracted by mini-css-extract-plugin
module.exports = {"headerIcon":"form_headerIcon_2jgGm","generalCard":"form_generalCard_e-e-d","rightTable":"form_rightTable_1C3LH","titleBig":"form_titleBig_3cQ4E"};